module.exports = __webpack_public_path__ + "img/perks_M Spring training presale.f63d0ff5.jpg";